import React from "react";
import RFamily from "../../PicesForPages/Refinancing_family.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function Refinancing() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent refinancingPageTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={RFamily}
          alt="RFamilyImage"
          className="background-video R_FamilyImage"
        />
        <div className="purchasetopBox refinancingPageTopBox">
          {/* The existing Purchase span */}
          <span>Refinancing</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span
              className="purchaseBottomLeftContent"
              // style={{ color: "red" }}
            >
              Please note that refinancing your current loan may increase the
              total finance charges over the life of the new loan.
            </span>
            <span className="purchaseBottomLeftContent">
              Refinancing is a strategic financial option often used to secure
              more favorable interest rates. If interest rates have declined
              since your previous home financing, refinancing could be a
              beneficial opportunity. Other common reasons to refinance include
              paying off a balloon payment, transitioning from an
              adjustable-rate mortgage to a fixed-rate mortgage, or leveraging
              your home’s equity through a cash-out refinance. Cash-out
              refinancing is frequently used for home renovations, funding
              education, or consolidating existing debts.
            </span>
            <span className="purchaseBottomLeftContent">
              An alternative way to access your home equity without refinancing
              is through a "home equity loan." This option may be particularly
              advantageous if your current mortgage has a lower interest rate
              than prevailing market rates or includes a prepayment penalty.
            </span>

            <span className="purchaseBottomLeftHeader">
              Benefits of Refinancing:
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>Lower Your Interest Rate</li>
              <li>Access Funds for Home Improvements</li>
              <li>Consolidate Existing Debt</li>
              <li>Reduce Your Monthly Payments</li>
            </ul>

            <span className="purchaseBottomLeftHeader">
              What You’ll Need to Refinance:
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>A Recent Appraisal and Financial Assessment</li>
              <li>Verification of Assets and Income</li>
              <li>
                <span>Apply Now to Discover the Required Documentation</span>
              </li>
            </ul>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default Refinancing;
